<div
  class="file-dropzone"
  [class.file-dropzone--compact]="variant === 'compact'"
  [class.is-drag-over]="dragOver"
  [class.is-disabled]="disabled"
  role="button"
  [attr.tabindex]="disabled ? null : 0"
  [attr.aria-disabled]="disabled ? 'true' : null"
  [attr.aria-label]="ariaLabel || title"
  (click)="openFilePicker()"
  (keydown.enter)="onKeydown($event)"
  (keydown.space)="onKeydown($event)"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)">
  <div
    class="file-dropzone__description"
    *ngIf="description && variant === 'panel'">
    {{ description }}
  </div>

  <div class="file-dropzone__visual">
    <!-- The preview, when a host provides one, stands where the icon would be: an avatar or a
         chosen document says more about the current state than a generic cloud. -->
    <div class="file-dropzone__preview">
      <ng-content select="[appFileDropzonePreview]"></ng-content>
    </div>
    <div class="file-dropzone__icon" *ngIf="!preview">
      <i-tabler [name]="icon" class="icon-32"></i-tabler>
    </div>

    <div class="file-dropzone__body">
      <div class="file-dropzone__title">{{ title }}</div>
      <div class="file-dropzone__separator" *ngIf="variant === 'panel'">or</div>
      <button
        mat-stroked-button
        color="primary"
        type="button"
        class="file-dropzone__browse"
        [disabled]="disabled"
        (click)="onBrowseClick($event)">
        <mat-icon>
          <i-tabler name="folder" class="icon-18"></i-tabler>
        </mat-icon>
        {{ browseLabel }}
      </button>
    </div>
  </div>

  <div class="file-dropzone__hint" *ngIf="hintText">{{ hintText }}</div>

  <!-- A refusal is the only thing a drop zone can say back: it stays until the next attempt. -->
  <div class="file-dropzone__error" *ngIf="errorMessage" role="alert">
    <i-tabler name="alert-triangle" class="icon-16"></i-tabler>
    <span>{{ errorMessage }}</span>
  </div>

  <input
    #fileInput
    type="file"
    class="file-dropzone__native"
    [accept]="accept"
    [multiple]="multiple"
    [disabled]="disabled"
    (change)="onFileSelected($event)" />
</div>
